// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"635":"a0c4ab6d","973":"f9df0685"}[chunkId] + ".css";
};